var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ninja-keys',{ref:"ninjakeys",attrs:{"no-auto-load-md-icons":true,"hideBreadcrumbs":"","placeholder":_vm.placeholder},on:{"selected":_vm.onSelected,"closed":_vm.onClosed}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }